<template>
  <div>
    <v-container fluid class="mx-12 my-6">
      <div class="card-label d-flex flex-row mb-4">
        <v-icon>mdi-account-group-outline</v-icon>
        <p class="mb-0 ml-4 subtitle-1 font-weight-bold">Tenants</p>
        <div class="flex-grow-1"></div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="font-weight-bold"
              depressed
              rounded
              color="primary"
              :disabled="!paymentAccess.report"
              @click="generateAllSOA"
              v-on="on"
            >
              <v-icon class="pr-1">mdi-file-table</v-icon>Generate SOA for all
              tenants
            </v-btn>
          </template>
          <p style="color: white">Download all SOA as PDF in a ZIP file</p>
        </v-tooltip>
      </div>
      <v-text-field
        v-model="searchString"
        solo
        flat
        append-icon="mdi-magnify"
        label="Search Tenant"
        hide-details
        class="mb-6"
        @click:append="searchAction"
        @keydown.enter="searchAction"
      >
      </v-text-field>
      <v-expansion-panels v-model="activeTenantsPanel" flat>
        <v-expansion-panel>
          <v-expansion-panel-header>Active Tenants</v-expansion-panel-header>
          <v-expansion-panel-content>
            <!-- <v-card class='px-8 d-flex flex-column justify-start main-container' v-if="currentTenantsToShow && access.read" elevation="0"> -->
            <v-row v-show="!loading">
              <v-col class="py-0" cols="12" md="6">
                <v-list class="py-0" dense>
                  <v-list-item
                    v-for="tenant in currentTenantsToShow.slice(
                      0,
                      currentTenantsToShow.length / 2 + 1
                    )"
                    :key="tenant.username"
                    dense
                    three-line
                    class="ma-1"
                  >
                    <v-list-item-avatar
                      color="grey"
                      class="clickable"
                      @click="redirectUser(tenant)"
                    >
                      <v-img
                        v-if="tenant.profilePicture"
                        :src="tenant.profilePicture"
                      ></v-img>
                      <v-icon v-else dark>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">
                        <span class="clickable" @click="redirectUser(tenant)">{{
                          getTenantName(tenant)
                        }}</span>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              icon
                              x-small
                              v-on="on"
                              @click="copyEmail(tenant.email1)"
                            >
                              <v-icon x-small>mdi-content-copy</v-icon>
                            </v-btn>
                          </template>
                          <p class="white--text">Copy Email Address</p>
                        </v-tooltip>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <div v-if="tenant.alias" class="d-flex flex-row">
                          Alias: {{ tenant.alias.name }}
                          <v-icon
                            x-small
                            class="ml-2"
                            color="primary"
                            @click="openAliasDialog(tenant)"
                            >mdi-pencil</v-icon
                          >
                        </div>
                        <a v-else @click="openAliasDialog(tenant)"
                          >Add an alias</a
                        >
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        Contact Number: {{ getTenantContactNumber(tenant) }}
                        <v-icon
                          x-small
                          class="ml-2"
                          color="primary"
                          @click="openUpdateContactDialog(tenant)"
                          >mdi-pencil</v-icon
                        >
                      </v-list-item-subtitle>
                      <!-- <v-list-item-subtitle><p class="caption">Contract Period: {{getParsedDate(tenant.moveInDate)}} to {{getParsedDate(tenant.moveOutDate)}}</p></v-list-item-subtitle> -->
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col class="py-0" cols="12" md="6">
                <v-list dense>
                  <v-list-item
                    v-for="tenant in currentTenantsToShow.slice(
                      currentTenantsToShow.length / 2 + 1
                    )"
                    :key="tenant.username"
                    dense
                    three-line
                    class="ma-1"
                  >
                    <v-list-item-avatar
                      color="grey"
                      class="clickable"
                      @click="redirectUser(tenant)"
                    >
                      <v-img
                        v-if="tenant.profilePicture"
                        :src="tenant.profilePicture"
                      ></v-img>
                      <v-icon v-else dark>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">
                        <span class="clickable" @click="redirectUser(tenant)">{{
                          getTenantName(tenant)
                        }}</span>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              icon
                              x-small
                              v-on="on"
                              @click="copyEmail(tenant.email1)"
                            >
                              <v-icon x-small>mdi-content-copy</v-icon>
                            </v-btn>
                          </template>
                          <p class="white--text">Copy Email Address</p>
                        </v-tooltip>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <div v-if="tenant.alias" class="d-flex flex-row">
                          Alias: {{ tenant.alias.name }}
                          <v-icon
                            x-small
                            class="ml-2"
                            color="primary"
                            @click="openAliasDialog(tenant)"
                            >mdi-pencil</v-icon
                          >
                        </div>
                        <a v-else @click="openAliasDialog(tenant)"
                          >Add an alias</a
                        >
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        Contact Number: {{ getTenantContactNumber(tenant) }}
                        <v-icon
                          x-small
                          class="ml-2"
                          color="primary"
                          @click="openUpdateContactDialog(tenant)"
                          >mdi-pencil</v-icon
                        >
                      </v-list-item-subtitle>
                      <!-- <v-list-item-subtitle><p class="caption">Contract Period: {{getParsedDate(tenant.moveInDate)}} to {{getParsedDate(tenant.moveOutDate)}}</p></v-list-item-subtitle> -->
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <v-skeleton-loader
              v-show="loading"
              ref="skeleton"
              type="table"
              loading
              class="mx-auto"
            ></v-skeleton-loader>
            <p
              v-if="!currentTenantsToShow.length"
              class="body-2"
              style="color: grey"
            >
              No Tenants to show.
            </p>
            <!-- </v-card> -->
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="card-label d-flex flex-row mb-4 mt-8">
        <v-icon>mdi-account-group-outline</v-icon>
        <p class="mb-0 ml-4 subtitle-1 font-weight-bold">Inactive Tenants</p>
      </div>
      <v-expansion-panels v-model="inactiveTenantsPanel" flat>
        <v-expansion-panel>
          <v-expansion-panel-header>Inactive Tenants</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row v-show="!loading">
              <v-col class="py-0" cols="12" md="6">
                <v-list class="py-0" dense>
                  <v-list-item
                    v-for="tenant in inactiveTenantsToShow.slice(
                      0,
                      inactiveTenantsToShow.length / 2 + 1
                    )"
                    :key="`${tenant.username}_old`"
                    dense
                    three-line
                    class="ma-1"
                  >
                    <v-list-item-avatar color="grey">
                      <!-- <a @click="redirectUser(tenant)"> -->
                      <v-img
                        v-if="tenant.profilePicture"
                        :src="tenant.profilePicture"
                      ></v-img>
                      <v-icon v-else dark>mdi-account</v-icon>
                      <!-- </a> -->
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">
                        <span class="clickable" @click="redirectUser(tenant)">{{
                          getTenantName(tenant)
                        }}</span>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              icon
                              x-small
                              v-on="on"
                              @click="copyEmail(tenant.email1)"
                            >
                              <v-icon x-small>mdi-content-copy</v-icon>
                            </v-btn>
                          </template>
                          <p class="white--text">Copy Email Address</p>
                        </v-tooltip>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <div v-if="tenant.alias" class="d-flex flex-row">
                          Alias: {{ tenant.alias.name }}
                          <v-icon
                            x-small
                            class="ml-2"
                            color="primary"
                            @click="openAliasDialog(tenant)"
                            >mdi-pencil</v-icon
                          >
                        </div>
                        <a v-else @click="openAliasDialog(tenant)"
                          >Add an alias</a
                        >
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        Contact Number: {{ getTenantContactNumber(tenant) }}
                        <v-icon
                          x-small
                          class="ml-2"
                          color="primary"
                          @click="openUpdateContactDialog(tenant)"
                          >mdi-pencil</v-icon
                        >
                      </v-list-item-subtitle>
                      <!-- <v-list-item-subtitle><p class="caption">Contract Period: {{getParsedDate(tenant.moveInDate)}} to {{getParsedDate(tenant.moveOutDate)}}</p></v-list-item-subtitle> -->
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col class="py-0" cols="12" md="6">
                <v-list class="py-0" dense>
                  <v-list-item
                    v-for="tenant in inactiveTenantsToShow.slice(
                      inactiveTenantsToShow.length / 2 + 1
                    )"
                    :key="`${tenant.username}_old`"
                    dense
                    three-line
                    class="ma-1"
                  >
                    <v-list-item-avatar color="grey">
                      <!-- <a @click="redirectUser(tenant)"> -->
                      <v-img
                        v-if="tenant.profilePicture"
                        :src="tenant.profilePicture"
                      ></v-img>
                      <v-icon v-else dark>mdi-account</v-icon>
                      <!-- </a> -->
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">
                        <span class="clickable" @click="redirectUser(tenant)">{{
                          getTenantName(tenant)
                        }}</span>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              icon
                              x-small
                              v-on="on"
                              @click="copyEmail(tenant.email1)"
                            >
                              <v-icon x-small>mdi-content-copy</v-icon>
                            </v-btn>
                          </template>
                          <p class="white--text">Copy Email Address</p>
                        </v-tooltip>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <div v-if="tenant.alias" class="d-flex flex-row">
                          Alias: {{ tenant.alias.name }}
                          <v-icon
                            x-small
                            class="ml-2"
                            color="primary"
                            @click="openAliasDialog(tenant)"
                            >mdi-pencil</v-icon
                          >
                        </div>
                        <a v-else @click="openAliasDialog(tenant)"
                          >Add an alias</a
                        >
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        Contact Number: {{ getTenantContactNumber(tenant) }}
                        <v-icon
                          x-small
                          class="ml-2"
                          color="primary"
                          @click="openUpdateContactDialog(tenant)"
                          >mdi-pencil</v-icon
                        >
                      </v-list-item-subtitle>
                      <!-- <v-list-item-subtitle><p class="caption">Contract Period: {{getParsedDate(tenant.moveInDate)}} to {{getParsedDate(tenant.moveOutDate)}}</p></v-list-item-subtitle> -->
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <v-skeleton-loader
              v-show="loading"
              ref="skeleton"
              type="table"
              loading
              class="mx-auto"
            ></v-skeleton-loader>
            <p
              v-if="!inactiveTenantsToShow.length"
              class="body-2"
              style="color: grey"
            >
              No Tenants to show.
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
    <v-dialog
      v-model="aliasDialog"
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancelAlias"
    >
      <v-card>
        <v-container class="px-10 pt-8">
          <p class="subtitle-1 font-weight-bold mb-2">Edit Tenant Alias</p>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="3">
              <p class="caption">Tenant:</p>
            </v-col>
            <v-col class="py-0" cols="12" sm="12" md="9">
              <p class="caption font-weight-bold">
                {{ getTenantName(selectedTenant) }}
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="3">
              <p class="caption">Username:</p>
            </v-col>
            <v-col class="py-0" cols="12" sm="12" md="9">
              <p class="caption font-weight-bold">
                {{ selectedTenant.username }}
              </p>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <v-text-field
            v-model="aliasName"
            label="Add an alias"
            prepend-icon="mdi-badge-account-outline"
          ></v-text-field>
          <v-card-actions class="pt-6">
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="submitAlias"
              >Submit</v-btn
            >
            <v-btn color="grey darken-1" text @click="cancelAlias"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <UpdateBedContact ref="updateBedContact"></UpdateBedContact>
    <v-snackbar v-model="snackbar">
      {{ snackbarMessage }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!-- <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay> -->
  </div>
</template>

<script>
import { dayjs } from '../util/date'
import UpdateBedContact from '../components/units/UpdateBedContact.vue'
import { searchTenantByString } from '../util/search'

export default {
  components: {
    UpdateBedContact
  },
  data() {
    return {
      searchString: '',
      currentTenantsToShow: [],
      inactiveTenantsToShow: [],
      loading: true,
      aliasDialog: false,
      selectedTenant: {},
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      cropperLabels: {
        submit: 'Submit',
        cancel: 'Cancel'
      },
      // imageBlob: null,
      // imageURL: '',
      aliasName: '',
      activeTenantsPanel: 0,
      inactiveTenantsPanel: 0,
      snackbar: false,
      snackbarMessage: '',
      currentProperty: ''
    }
  },
  computed: {
    tenants() {
      return this.$store.getters['users/getTenants']
    },
    access() {
      return this.$root.$roleAccess('tenants').access
    },
    property() {
      return this.$store.getters['properties/getProperty']
    },
    currentTenants() {
      return this.tenants.filter(
        (t) => t.status === 'active' || t.status === 'expired'
      )
    },
    inactiveTenants() {
      return this.tenants.filter((t) => t.status === 'inactive')
    },
    user() {
      return this.$store.getters['auth/getUser']
    },
    paymentAccess() {
      return this.$root.$roleAccess('payment').access
    }
  },
  async mounted() {
    await this.reloadTenants()
    if (this.user.property_details && this.property) {
      this.currentProperty = this.property.propertyName
    }
  },
  methods: {
    async reloadTenants() {
      await this.$store.dispatch('users/fetchAliasesAction')
      await this.$store.dispatch('users/fetchTenantsAction')
      this.currentTenantsToShow = this.currentTenants.filter(
        (v, i, a) => a.findIndex((t) => t.username === v.username) === i
      )
      this.inactiveTenantsToShow = this.inactiveTenants.filter((v, i, a) => {
        return (
          a.findIndex((t) => t.username === v.username) === i &&
          this.currentTenantsToShow.findIndex(
            (t) => t.username === v.username
          ) == -1
        )
      })
      this.loading = false
    },
    getTenantName(tenant) {
      let displayName = ''
      if (tenant.firstName) {
        displayName += tenant.firstName + ' '
        if (tenant.lastName) {
          displayName += tenant.lastName + ' '
        }
      } else {
        return (displayName = tenant.username)
      }

      return displayName
    },
    getParsedDate(date) {
      return dayjs(date).format('MMMM DD, YYYY')
    },
    redirectUser(tenant) {
      this.$router.push(`/user/${tenant.username}`)
      // this.$router.push(`/bed/${tenant.bedId}`)
    },
    searchAction() {
      this.currentTenantsToShow = this.currentTenants
        .filter((tenant) => searchTenantByString(tenant, this.searchString))
        .filter(
          (v, i, a) => a.findIndex((t) => t.username === v.username) === i
        )

      this.inactiveTenantsToShow = this.inactiveTenants
        .filter((tenant) => searchTenantByString(tenant, this.searchString))
        .filter(
          (v, i, a) => a.findIndex((t) => t.username === v.username) === i
        )
    },
    openAliasDialog(tenant) {
      this.selectedTenant = tenant
      this.aliasName = tenant.alias && tenant.alias.name
      this.aliasDialog = true
    },
    async submitAlias() {
      this.$root.$setLoading(true)
      const success = await this.$store.dispatch('users/updateAliasAction', {
        propertyId: this.property.propertyId,
        tenantId: this.selectedTenant.userId,
        name: this.aliasName
        // profilePicture: this.imageBlob,
      })
      if (success) {
        await this.reloadTenants()
        this.aliasDialog = false
        this.$root.$setLoading(false)
        // window.location.reload()
      }
    },
    cancelAlias() {
      this.aliasDialog = false
      // this.imageURL = '',
      // this.imageBlob = null,
      this.selectedTenant = {}
      this.aliasName = ''
    },
    getTenantContactNumber(tenant) {
      if (tenant.alias && tenant.alias.contactNumber)
        return tenant.alias.contactNumber
      if (tenant.tenant_details && tenant.tenant_details.contactNumber1) {
        return tenant.tenant_details.contactNumber1
      }
      return ''
    },
    openUpdateContactDialog(tenant) {
      this.$refs.updateBedContact.open({
        tenantId: tenant.tenantId,
        contact: this.getTenantContactNumber(tenant)
      })
    },
    copyEmail(str) {
      const el = document.createElement('textarea')
      el.value = str
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      this.snackbarMessage = 'Email address copied to clipboard!'
      this.snackbar = true
    },
    async generateAllSOA() {
      this.loading = true
      let SOA = {
        tenants: [],
        name: this.currentProperty
      }
      for (let tenant of this.currentTenantsToShow) {
        SOA.tenants.push({
          tenantId: tenant.tenantId
        })
      }
      await this.$store.dispatch('units/fetchMultipleSOAAction', SOA)
      this.loading = false
    }
    // profilePictureUploadHandler(cropper) {
    //   cropper.getCroppedCanvas().toBlob(blob => {
    //   this.imageBlob = blob
    //   this.imageURL = URL.createObjectURL(blob);
    //     // this.$store.dispatch('users/updateUserProfilePictureAction', {profilePicture: blob}).then(() => {
    //     //   // this.$router.go()
    //     //   this.loading = false
    //     //   window.location.reload()
    //     // })
    //   })
    // },
  }
}
</script>

<style scoped>
.container {
  width: auto;
}
.container.main-container {
  min-height: 100vh;
}
.v-card {
  border-radius: 12px !important;
}
.v-input {
  border-radius: 10px;
}
table tbody tr td {
  border: none !important;
  border-bottom: none !important;
}
p {
  margin-bottom: 0;
}
.clickable {
  cursor: pointer;
}
</style>
